import React, { useCallback } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useDispatch } from 'react-redux';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

import { editTimecard } from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import { trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
} from 'util/tracking_constants';

import Issue from './Issue';

const MissingBreaks = ({
  issue,
  addTimebreak,
  dismissMissedBreaks,
  setChangesMade,
}) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleAddMissingBreaks = useCallback(() => {
    dispatch(editTimecard());
    setChangesMade(true);

    issue.getIn(['meta', 'missing_breaks']).forEach(missedBreak =>
      addTimebreak({
        key: uniqueId('NEW-TIMEBREAK'),
        start_at: missedBreak.get('start_at'),
        end_at: missedBreak.get('end_at'),
        mandated_break_id: missedBreak.get('mandated_break_id'),
        paid: missedBreak.get('paid'),
      })
    );
  });

  const handleDismissMissingBreaks = useCallback(() => {
    trackUxEvent({
      productArea: PRODUCT_AREAS.TIMESHEETS,
      eventCategory: EVENT_CATEGORIES.TIMECARD_DETAIL,
      eventAction: EVENT_ACTIONS.DISMISS_BREAK_CLICKED_V3,
    });

    const mandated_break_ids = [];
    issue.getIn(['meta', 'missing_breaks']).forEach(missedBreak => {
      const id = missedBreak.get('mandated_break_id');
      if (mandated_break_ids.indexOf(id) === -1) {
        mandated_break_ids.push(id);
      }
    });

    mandated_break_ids.forEach(id => dismissMissedBreaks(id));
  }, [issue, dismissMissedBreaks]);

  return (
    <Issue
      issue={issue}
      onClick={handleAddMissingBreaks}
      onDismissClick={handleDismissMissingBreaks}
    />
  );
};

MissingBreaks.propTypes = {
  issue: ImmutablePropTypes.map.isRequired,
  addTimebreak: PropTypes.func.isRequired,
  dismissMissedBreaks: PropTypes.func.isRequired,
  setChangesMade: PropTypes.func.isRequired,
};

export default MissingBreaks;
